<template>
  <div >{{ ActDescBtn }}
    <table style="position: absolute;" width="100%" :height="this.windowSize.height-8"
      :max-height="this.windowSize.height-8"  >
      <!-- ContenidoBase-PagoAPagares-->
      <tr max-height="48px" height="48px" >
        <ContenidoBase :titulo="'Pago a Pagares'" :descripcion="'Realiza los Pagos a los pagareses pendiente de los cliente'"
          :EstadoBtn="EstadoBtn" @abrirBarraTablaDinamica="abrirTabla" @MethodNuevo="newwnuevo" @MethodGuardar="save"
          @MethodEliminar="remove" @MethodAnular="anular" @MethodImprimir="imprimirList"
           />
      </tr>
      <!-- fn ContenidoBase-PagoAPagares -->
      <tr>
        <!-- BarraPrimaria-PagoAPagares  --------------------------------------------------------------------------------->
        <td width="109" :max-height="this.windowSize.height-96" v-show="BarraTablaDinamicaAprir">
          <div class="overflow-y-auto "
            v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px'  }">

            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <center>
                  <!-- <v-btn-toggle></v-btn-toggle> -->
                  <v-btn small width="95%" color="yellow accent-4" @click.prevent="actualiza_tb_ver">
                    <i style="font-size: 25px;" class="fa fa-eye"> </i> ver
                  </v-btn>

                </center>


                <BarraDinamicaNormal
              :nombre="'Pago a Pagares'"
              @EmitDAta="datostabla"
              @EmitBuscar="filtro"
              :SeachNombre="'Búsqueda general'"
              :list="list"

              :headers="[
        { text: 'Código', value: 'codigo' },
        { text: 'Descripcion', value: 'descripcion' } 
        ]"
              :ContListSlot="[
              {Text:'Código', NomValue:'codigo', Ctsl:1, Type:0, State:true},
              {Text:'Descripción', NomValue:'descripcion', Ctsl:1, Type:0, State:true},
              {Text:'Estado',NomValue:'activo', Ctsl:1, Type:0.1, State:true},
              ]"
            />

              </template>
            </v-tooltip>
            
          </div>
        </td>
        <!-- fn BarraPrimaria-PagoAPagares  ---------------------------------------------------------------------------------->
        <!-- contenido central ------------------------------------------------------------------------------ -->
        <td :max-height="this.windowSize.height-96">

          <v-app id="inspire" class="overflow-y-auto" v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' }">
           <!-- Formulario-PagoAPagares  -->
            <!-- <div class="px-2">

              <v-card color="grey lighten-3">

                <div class="px-2">

                  <v-form ref="form" @submit.prevent="" v-model="valid" lazy-validation>
                    <v-row>
                      <v-col cols="12" lg="12" md="8" sm="6">
                        <v-text-field v-model="PagoPagares.descripcion" :rules="[$rules.required]"
                          autocomplete="off" label="Descripcion" required outlined dense>
                          <template v-slot:prepend>
                            <vue-fontawesome icon="edit" size="2" color="black"></vue-fontawesome>
                          </template>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" lg="12" md="12" sm="12">
                        <v-switch label="Activo" v-model="PagoPagares.activado"></v-switch>
                      </v-col>
                    </v-row>

                  </v-form>


                </div>
              </v-card>
            </div> -->
           
            <!-- fn Formulario-PagoAPagares  -->

            <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
              <v-card color="grey lighten-3">
                <!-- Formulario-formPagares  -->
                <v-form ref="formPagares" @submit.prevent="" v-model="valid" lazy-validation>
                    <v-row no-gutters>
                          <!-- F- busquedaFiltro  -->
                          <v-col class="pa-0 ma-0 py-0 my-0 pt-1"   cols="12" md="4" sm="4">
                            <v-combobox hide-details autocomplete="off" dense outlined label="Cliente:" :items="Rcliente"
                                            item-text="codnom" @keyup="CbFilcliente" v-model="PagoPagares.cliente"
                                            @blur="SelctCbClient" @focus="cargarCliente" no-filter>
                                            <template slot="item" slot-scope="item">
                                            <span style="display:none;">{{ item.item.codnom = `${item.item.codigo} - ${item.item.nombre.trim()} ` }}</span>
                                            <span v-if="item.item!=null && item.item.hasOwnProperty('codigo')" class="fontSize13"><b>{{ item.item.codigo}}</b> - {{item.item.nombre.trim()}}</span>
                                            </template>

                                            <template v-slot:selection="{ attrs, item, parent, selected }">
                                              <span v-if="item!=null && item.hasOwnProperty('codigo')" class="fontSize13 colorNombre"><b>{{ item.codigo}}</b> - {{item.nombre.trim()}}</span>
                                            </template>
                                            <template v-slot:prepend>
                                              <i style="font-size: 20px;" class="fa fa-user-circle-o"></i>
                                            </template>
                                            <template v-slot:append-outer>
                                            <v-tooltip top>
                                              <template v-slot:activator="{ on }">

                                                <v-btn @click.prevent="buscarPagare()" v-on="on" color="blue darken-3" fab
                                                  x-small dark>
                                                  <i style="font-size: 20px;" class="fa fa-search"></i>
                                                </v-btn>

                                              </template>
                                              <span>BUSCAR FACTURA</span>
                                            </v-tooltip>
                                    </template>
                              </v-combobox>
                          </v-col>
                          <v-col   class="pa-0 ma-0 py-0 my-0"   cols="12" md="2" sm="2">
                              <div>
                                <v-switch  hide-details class="mt-2"  color="teal" label=""
                                v-model="opcionFiltroPendiente">
                                <template v-slot:label>
                                  <strong v-if="opcionFiltroPendiente == true"
                                    style="color:#000000; font-size:13px;">FINALIZANDO 
                                 </strong>
                                  <strong v-if="opcionFiltroPendiente == false"
                                    style="color:#000000; font-size:13px;">PENDIENTE</strong>
                                </template>
                              </v-switch>
                              </div>
                            </v-col>
                          
                          <!-- F- busquedaFiltro  -->
                            <v-col   class="pa-0 ma-0 py-0 my-0"   cols="12" md="3" sm="3">
                              <div v-if="DatosPagareFactura !=null && estadoListaContratoBk(DatosPagareFactura)==true">
                              <b style="font-size:20px;" :class="`d-flex justify-center green--text`"> PAGARES COMPLETO </b>
                              </div>
                            </v-col>

                            <!-- F- busquedaFiltro  -->
                            <v-col   class="pa-0 ma-0 py-0 my-0"   cols="12" md="3" sm="3">
                              <div v-if="DatosPagareFactura !=null">
                                <v-radio-group  hide-details class="py-0"  v-model="opcionImprecion" row>     
                                    <v-radio label="RECIBO" color="green" :value="1"></v-radio>
                                    <v-radio label="CONTRATO" color="green" :value="2"></v-radio>                                                     
                                </v-radio-group>
                              </div>
                            </v-col>


                            <!-- COL GRUPO 1: -->
                            <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
                              <v-row no-gutters>
                            <!-- COL TABLA: LISTA DE PAGARES -->
                            <v-col class="pa-0 ma-0 py-0 my-0"   cols="12" md="6" sm="6" >
                                <v-col style="background-color:#dd4b39;" class="pa-0 ma-0 py-0 my-0 px-2" cols="12" md="12" sm="12">
                               <span :class="`d-flex justify-start white--text`"> <b> LISTA DE CONTRATO</b></span>
                                </v-col>
                              <div v-if="listPagareCliente.length>0" style="border: 1px solid #000000;">

                                <!-- TABLA: LISTA DE PAGARES -->
                                <div style="max-height:209px; height:209px;" class="overflow-x-auto">
                                <v-data-table  class="RowSelectColor elevation-1 TbSize13" :single-select="true" item-key="indx"
                                  :show-select="true" v-model="selectedPagare" @item-selected="ObtenerDatoSelectPagare"
                                  @click:row="DatostablaPagare" :headers="[
                                    { text: '# CONTRATO', sortable: false, value: 'secuencia', width: 129, class: ['no-gutters black--text'] },
                                    { text: 'FECHA', sortable: false, value: 'nuevaFecha', width: 120, class: ['no-gutters black--text'] },    
                                    { text: 'VALOR PRESTAMO', sortable: false, value: 'valorPrestamo',  width: 105, class: ['no-gutters black--text'] },
                                    { text: 'ESTADO', sortable: false, value: 'estado', width: 20, class: ['no-gutters black--text'] }
                              
                              ]" dense :items="filterlistPagareCliente(listPagareCliente)" :hide-default-footer="!opcionFiltroPendiente" :footer-props="arrayPropiedases"  :items-per-page="-1">

                                  <template v-slot:item.nuevaFecha="props">
                                    <span style="font-size:13px; display:none;">{{ props.item.indx =
                                    listPagareCliente.indexOf(props.item)
                                    }}</span>
                                    <span style="font-size:13px;">{{ FormatoFecha(props.item.nuevaFecha) }}</span>
                                  </template>

                                  <template v-slot:item.secuencia="props">
                                    <span style="font-size:13px;">{{ props.item.secuencia}}</span>
                                  </template>

                                  <template v-slot:item.cliente.nombre="props">
                                    <span v-if="props.item.cliente.nombre != null" style="font-size:13px;">{{ props.item.cliente.nombre.trim() }}
                                    </span>
                                  </template>

                                  <template v-slot:item.valorPrestamo="props">
                                    <span style="font-size:13px;">{{ currencyFormatter(props.item.valorPrestamo) }}</span>
                                  </template> 
                                  
                                  <template v-slot:item.estado="props"> 
                                    <span v-if="estadoListaContrato(props.item)==true" style="font-size:13px;" class="green--text">FINALIZADO</span>
                                    <span v-if="estadoListaContrato(props.item)==false" style="font-size:13px;" class="red--text">PENDIENTE</span>
                                  </template>


                                </v-data-table>
                                </div>
                                <!-- FIN TABLA: LISTA DE PAGARES -->
                              </div>
                            </v-col>
                             <!-- FIN COLTABLA: LISTA DE PAGARES -->

                               <!-- COL: FORMA DE PAGO -->
                               <v-col class="pa-0 ma-0 py-0 my-0"   cols="12" md="6" sm="6">
                                <v-col style="background-color:#dd4b39;" class="pa-0 ma-0 py-0 my-0 px-2" cols="12" md="12" sm="12">
                               <span :class="`d-flex justify-start white--text`"> <b> FORMA DE PAGO</b></span>
                                </v-col>
                                <div style="border: 1px solid #000000;  ">
                                  <v-combobox class="fontSize13" v-model="PagoPagares.caja" label="caja" :rules="[$rules.required]" outlined dense autocomplete="off"
                                  :items="RCaja" item-text="descripcion" @blur="SelctCbCaja" @focus="cargarCaja"
                                  :disabled="disableCompntsCamp()" id="formdisabledInput" style="font-size: 13px;" hide-details >
                                  <template v-slot:prepend>
                                    <i style="font-size: 20px;" class="fa fa-cube"></i>
                                  </template>
                                </v-combobox>
                                
                                <!-- SUB-COL: FORMA DE PAGO -->
                                <v-row no-gutters>
                                  <v-col class="pa-0 ma-0 py-0 my-0 pb-4"   cols="3" md="3" sm="3">
                                  <v-radio-group  hide-details class="mt-4" v-model="PagoPagares.opcion" column>
                                  <v-radio class="pa-0 ma-0 py-0 my-0"   label="Efectivo" color="green darken-3" :value="1"></v-radio>
                                  <v-radio class="pa-0 ma-0 py-0 my-0"  label="Cheque" color="teal lighten-2" :value="2"></v-radio>
                                  <v-radio class="pa-0 ma-0 py-0 my-0"  label="Transferencia" color="cyan lighten-2" :value="3"></v-radio>
                                  <v-radio class="pa-0 ma-0 py-0 my-0"  label="Tarjeta" color="blue lighten-4" :value="4"></v-radio>
                                </v-radio-group>
                                </v-col> 
                                <v-col class="pa-0 ma-0 py-0 my-0"   cols="9" md="9" sm="9">
                                 
                                  <div v-if="PagoPagares.opcion == 2 || PagoPagares.opcion == 3">
                                      <!-------------------------------------------------- Numero-->
                                      <v-text-field class="mt-1 fontSize13" hide-details label="Numero" dense outlined v-model="PagoPagares.numCuenta"
                                        :rules="[$rules.required]"  id="formdisabledInput">
                                        <template v-slot:prepend>
                                          <i style="font-size: 20px;" class="fa fa-hashtag"></i>
                                        </template>
                                      </v-text-field>

                                            <!-------------------------------------------------- banco-->
                                      <v-text-field class="mt-1 fontSize13" hide-details label="Banco" dense outlined v-model="PagoPagares.banco"
                                        :rules="[$rules.required]"  id="formdisabledInput">
                                        <template v-slot:prepend>
                                          <i style="font-size: 20px;" class="fa fa-university"></i>
                                        </template>
                                      </v-text-field>
                                  </div>

                                  <div v-if="PagoPagares.opcion == 4">

                                    <v-combobox class="mt-1" hide-details v-model="PagoPagares.tarjetaTipo" label="tipo tarjeta:" required outlined dense
                                  :rules="[$rules.required]" autocomplete="off" :items="RBanco" item-text="nombre"
                                  @blur="SelctCbBanco" @focus="cargarBanco"  id="formdisabledInput">
                                  <template v-slot:prepend>
                                    <i style="font-size: 20px;" class="fa fa-credit-card"></i>
                                  </template>
                                </v-combobox>
                                    <!-------------------------------------------------- Numero Tarjeta-->
                                    <v-text-field class="mt-1" hide-details label="Numero" dense outlined v-model="PagoPagares.numeroTarjeta"
                                      :rules="[$rules.required]"  id="formdisabledInput">
                                      <template v-slot:prepend>
                                        <i style="font-size: 20px;" class="fa fa-hashtag"></i>
                                      </template>
                                    </v-text-field>
                                    </div>

                                <!-------------------------------------------------- Monto v-on:blur="ValidarRecalculos" -->
                                <VueAutonumeric class="mt-1" hide-details label="Monto a pagar:" dense outlined autocomplete="off"
                                  v-model.number="PagoPagares.monto" @input="procesarCalculoPagos" @blur="blurMontopagar"  :rules="[$rules.required]"
                                     style="font-size: 13px;">
                                  <template v-slot:prepend>
                                    <i style="font-size: 20px;" class="fa fa-money"></i>
                                  </template>
                                </VueAutonumeric>
                              
                                </v-col>
                                </v-row>
                                 <!-- SUB-COL: FORMA DE PAGO -->
                              <!-- BTN: APLICAR -->
                                   <v-hover v-slot:default="{ hover }" close-delay="200">
                                    <v-btn dense :elevation="hover ? 24 : 2" :outlined="hover ? false : true" dark block
                                      :color="hover ? 'green darken-3' : 'green'" v-ripple="{ class: `white--text` }"
                                      @click.prevent="aplicarPagares" :disabled="estadoListaContratoBk(DatosPagareFactura)==true">

                                      <h2>APLICAR PAGO</h2>

                                    </v-btn>
                                    </v-hover>

                              <!-- FIN BTN: APLICAR -->

                                </div>
                              </v-col>
                               <!-- COL: FORMA DE PAGO -->

                             </v-row>
                            </v-col>
                          <!-- FIN COL GRUPO 1: -->

                           <!-- COL GRUPO 2: -->
                           <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
                            <v-row no-gutters>
                            <!-- COL:DETALLE CONTRATO-->
                            <v-col class="pa-0 ma-0 py-0 my-0"   cols="12" md="5" sm="5" >
                              <v-col style="background-color:#dd4b39;" class="pa-0 ma-0 py-0 my-0 px-2" cols="12" md="12" sm="12">
                               <span :class="`d-flex justify-start white--text`"> <b> DETALLE DEL CONTRATO</b></span>
                                </v-col>
                                 <!-- SUB-COL: DETALLE CONTRATO -->
                                 <v-row >
                                  <!-- SUB-COL 1: DC-->
                                  <v-col cols="12" md="6" sm="6" >   
                                    <div v-if="DatosPagareFactura!=null" >                                         
                                                  <!------ Fecha -->
                                      <v-text-field disabled class="fontSize13" id="formdisabledInput" hide-details dense outlined type="date" label="Fecha inicial:" style="font-size:13px;"
                                        v-model="DatosPagareFactura.fecha" :rules="[$rules.required]" >

                                        <template v-slot:prepend-inner>
                                          <i style="font-size: 20px;" class="fa fa-calendar"></i>
                                        </template>
                                      </v-text-field>
                                      <!------ valor prestamo -->
                                      <VueAutonumeric disabled class="fontSize13 mt-1" id="formdisabledInput" hide-details  label="Valor del prestamo:" dense outlined autocomplete="off"
                                        v-model.number="DatosPagareFactura.valorPrestamo"  style="font-size: 13px;">
                                        <template v-slot:prepend-inner>
                                          <i style="font-size: 20px;" class="fa fa-money"></i>
                                        </template>
                                      </VueAutonumeric>
                                      <!------ inicio -->
                                      <VueAutonumeric disabled class="fontSize13 mt-1"  id="formdisabledInput" hide-details label="Inicio:" autocomplete="off" dense outlined
                                        v-model.number="DatosPagareFactura.inicial"  >
                                        <template v-slot:prepend-inner>
                                          <i style="font-size: 20px;" class="fa fa-italic"></i>
                                        </template>
                                      </VueAutonumeric>
                                      <!------ inicio -->

                                      <!------ Valor Recibido: -->
                                      <VueAutonumeric disabled class="fontSize13 mt-1" v-if="false" id="formdisabledInput" hide-details  label="Valor Recibido:" dense outlined autocomplete="off"
                                        v-model.number="DatosPagareFactura.valorRecibido" style="font-size: 13px;">
                                        <template v-slot:prepend-inner>
                                          <i style="font-size: 20px;" class="fa fa-money"></i>
                                        </template>
                                      </VueAutonumeric>


                                      <!------ % de Interes: -->
                                      <VueAutonumeric disabled class="fontSize13 mt-1" id="formdisabledInput" hide-details  label="% de Interes(Ganado):" dense outlined autocomplete="off"
                                        v-model.number="DatosPagareFactura.porcientoInteres" style="font-size: 13px;" >
                                        <template v-slot:prepend-inner>
                                          <i style="font-size: 20px;" class="fa fa-percent"></i>
                                        </template>
                                      </VueAutonumeric>

                                      <!------ Cantidad Cuotas: -->
                                      <VueAutonumeric disabled class="fontSize13 mt-1" id="formdisabledInput" hide-details  label="Cantidad Cuotas:" dense outlined autocomplete="off"
                                        v-model.number="DatosPagareFactura.cantidadCuotas"   
                                        style="font-size: 13px;" :rules="[$rules.required]">
                                        <template v-slot:prepend-inner>
                                          <i style="font-size: 20px;" class="fa fa-sort-numeric-asc"></i>
                                        </template>
                                      </VueAutonumeric>
                                      <v-text-field disabled class="fontSize13 mt-1" hide-details id="formdisabledInput" label="Prórroga:" dense outlined type="number" 
                                                  v-model.number="DatosPagareFactura.prorroga" :rules="[$rules.Numericc]"
                                                  suffix="DIA">
                                                  <template v-slot:prepend-inner>
                                                  <i style="font-size: 20px;" class="fa fa-sun-o"></i>
                                                  </template>      
                                      </v-text-field>

                                      </div> 
                                     
                                  </v-col>
                                  <!-- SUB-COL 1: DC -->

                                   <!-- SUB-COL 2: DC-->
                                   <v-col cols="12" md="6" sm="6" >
                                    <div v-if="DatosPagareFactura!=null">
                                     <!------ Capital a pagar: -->
                                          <VueAutonumeric disabled class="fontSize13" hide-details id="formdisabledInput" label="Capital a pagar:" dense outlined disabled
                                            autocomplete="off" v-model.number="DatosPagareFactura.capitalPaga"
                                            style="font-size: 13px;">
                                            <template v-slot:prepend-inner>
                                              <i style="font-size: 20px;" class="fa fa-money"></i>
                                            </template>
                                          </VueAutonumeric>

                                          <!------ Interes a pagar: -->
                                          <VueAutonumeric disabled class="fontSize13 mt-1" hide-details id="formdisabledInput" label="Interes a pagar:" dense outlined autocomplete="off"
                                            v-model.number="DatosPagareFactura.interesTotal" style="font-size: 13px;">
                                            <template v-slot:prepend-inner>
                                              <i style="font-size: 20px;" class="fa fa-percent"></i>
                                            </template>
                                          </VueAutonumeric>

                                          <!------ Monto Cuotas -->
                                          <VueAutonumeric disabled class="fontSize13 mt-1" hide-details id="formdisabledInput" label="Monto Cuotas:" dense outlined autocomplete="off"
                                            v-model.number="DatosPagareFactura.montoCuota" style="font-size: 13px;" >
                                            <template v-slot:prepend-inner>
                                              <i style="font-size: 20px;" class="fa fa-money"></i>
                                            </template>
                                          </VueAutonumeric>

                                          <!-- Tipo Interes -->
                                          <v-combobox disabled class="fontSize13 mt-1" hide-details id="formdisabledInput" autocomplete="off" dense outlined label="Tipo Interes:"
                                            :items="RTipoInteres" item-text="descripcion" style="font-size: 13px;"
                                            v-model="DatosPagareFactura.tipoInteres" 
                                            :rules="[$rules.required]">
                                            <template v-slot:prepend-inner>
                                              <i style="font-size: 20px;" class="fa fa-tags"></i>
                                            </template>
                                          </v-combobox>

                                          <!------ Intervalos de días: -->
                                          <v-text-field disabled class="fontSize13 mt-1" hide-details id="formdisabledInput" label="Intervalos de días:" autocomplete="off" dense outlined
                                             v-model="DatosPagareFactura.tipoInteres.dia">
                                            <template v-slot:prepend-inner>
                                              <i style="font-size: 20px;" class="fa fa-sun-o"></i>
                                            </template>
                                          </v-text-field>

                                          <VueAutonumeric disabled class="fontSize13 mt-1" hide-details id="formdisabledInput" label="% Interes Mora:" dense outlined autocomplete="off"
                                            v-model.number="DatosPagareFactura.interesMora" style="font-size: 13px;">
                                            <template v-slot:prepend-inner>
                                              <i style="font-size: 20px;" class="fa fa-percent"></i>
                                            </template>
                                          </VueAutonumeric>

                                            
                                          </div>
                                  </v-col>
                                  <!-- SUB-COL 2: DC -->

                                </v-row>

                                <!-- SUB-COL: DETALLE CONTRATO -->

                            </v-col>
                            <!-- FIN COL : DETALLE CONTRATO-->


                             <!-- COL TABLA : DISTRIBUCION CONTRATO-->
                             <v-col class="pa-0 ma-0 py-0 my-0"   cols="12" md="7" sm="7" >
                              <v-col style="background-color:#dd4b39;" class="pa-0 ma-0 py-0 my-0 px-2" cols="12" md="12" sm="12">
                               <span :class="`d-flex justify-center white--text`"> <b> DISTRIBUCIÓN DE CUOTAS</b></span>
                                </v-col>
                                <!-- { text: 'Tipo', sortable: false, value: 'tipo', width: 100, class: ['no-gutters  black--text'] }, -->
                    <div v-if="DatosPagareFactura!=null" style="max-height:400px; height:400px;" class="overflow-x-auto" >
                  <v-data-table class="RowSelectColor" item-key="indx" :headers="[
                    { text: 'PAGO #', sortable: false, value: 'pago', width: 50, class: ['no-gutters  black--text'] },
                    { text: 'FECHA VENC.', sortable: false, value: 'fechaVencimiento', width: 110, class: ['no-gutters  black--text'] },
                    { text: 'CAPITAL', sortable: false, value: 'capital', width: 'auto', width: 105, class: ['no-gutters  black--text'] },
                    { text: 'INTERES', sortable: false, value: 'interes', width: 'auto', width: 105, class: ['no-gutters  black--text'] },
                    { text: 'MORA', sortable: false, value: 'interesMoraValor', width: 'auto', width: 105, class: ['no-gutters  black--text'] },
                    { text: 'PENDIENTE', sortable: false, value: 'pendiente', width: 'auto', width: 105, class: ['no-gutters  black--text'] },
                    { text: 'ABONO', sortable: false, value: 'abono', width: 'auto', width: 105, class: ['no-gutters  black--text'] },
                    { text: 'TOTAL', sortable: false, value: 'total', width: 'auto', width: 105, class: ['no-gutters  black--text'] },
                    { text: '', sortable: false, value: 'saldado', width: 20, class: ['no-gutters black--text'] } 
                  ]" dense :items="DatosPagareFactura.pagareDetalleList" :footer-props="arrayPropiedases" :items-per-page="20">

                    <template v-slot:item.tipo="props">
                      <span style="font-size:13px; display:none;">{{ props.item.indx =
                      DatosPagareFactura.pagareDetalleList.indexOf(props.item)
                      }}</span>
                      <span style="font-size:13px;">{{ props.item.tipo }}</span>
                    </template>

                    <template v-slot:item.pago="props">
                      <span style="font-size:13px;">{{ props.item.pago }} </span>
                    </template>

                    <template v-slot:item.fechaVencimiento="props">
                      <span style="font-size:13px;">{{ FormatoFecha(props.item.fechaVencimiento) }} </span>
                    </template>

                    <template v-slot:item.capital="props">
                      <span style="font-size:13px;">{{ currencyFormatter(props.item.capital) }}</span>
                    </template>

                    <template v-slot:item.interes="props">
                      <span style="font-size:13px;">{{ currencyFormatter(props.item.interes) }}</span>
                    </template>

                    <template v-slot:item.interesMoraValor="props">
                      <!-- <span style="font-size:13px;">{{ currencyFormatter(calcularMoraDistCuota(props.item)) }}</span>  -->
                      <span style="font-size:13px;">{{ currencyFormatter(props.item.interesMoraValor) }}</span>
                    </template>

                    <template v-slot:item.pendiente="props">
                      <span style="font-size:13px;">{{ currencyFormatter(props.item.pendiente) }}</span>
                    </template>

                    <template v-slot:item.abono="props">
                      <span style="font-size:13px;">{{ currencyFormatter(props.item.abono) }}</span>
                    </template>

                    <template v-slot:item.total="props">
                      <span style="font-size:13px;">{{ currencyFormatter(props.item.total) }}</span>
                      <!-- <span style="font-size:13px;" >{{ currencyFormatter(props.item.total) }}</span> -->
                    </template>

                    <template v-slot:item.saldado="props"> 
                    <span  class=" pa-0 ma-0 py-0 my-0 px-3" > 
                    <i v-if="props.item.saldado==true" style="font-size: 20px;" class="fa fa-check-circle green--text"></i>
                    <i v-if="props.item.saldado==false" style="font-size: 20px;" class="fa fa-times-circle-o red--text"></i>
                    </span> 
                   </template>

                   <template v-slot:body.append v-if="windowSize.width >600">
<tr>  
<td class="border-top-bottom"  ><strong></strong></td>
<td class="border-top-bottom"  ><strong class="d-flex justify-end" style="font-size:13px; color: #00838F;">TOTAL:</strong></td>
<td class="border-total" ><strong class="d-flex justify-start" style="font-size:13px; color: #00838F;"> {{currencyFormatter(totales.capital)}} </strong></td>                                                                         
<td class="border-total" ><strong class="d-flex justify-start" style="font-size:13px; color: #00838F;"> {{currencyFormatter(totales.interes)}} </strong></td>
<td class="border-total" ><strong class="d-flex justify-start" style="font-size:13px; color: #00838F;"> {{currencyFormatter(totales.mora)}} </strong></td>
<td class="border-total" ><strong class="d-flex justify-start" style="font-size:13px; color: #00838F;"> {{currencyFormatter(totales.pendiente)}} </strong></td>
<td class="border-total" ><strong class="d-flex justify-start" style="font-size:13px; color: #00838F;"> {{currencyFormatter(totales.abono)}} </strong></td>
<td class="border-total" ><strong class="d-flex justify-start" style="font-size:13px; color: #00838F;"> {{currencyFormatter(totales.total)}} </strong></td>
<td class="border-top-bottom"  ><strong></strong></td>
</tr>
 </template>
 <template v-slot:footer v-if="windowSize.width<=600">
<v-list-item style="font-size: 70%;" class="white--text" > 
      <v-list-item-content>
        <span>TOTAL CAPITAL:{{currencyFormatter(totales.capital)}}</span>
        <span>TOTAL INTERES:{{currencyFormatter(totales.interes)}}</span>
        <span>TOTAL MORA:{{currencyFormatter(totales.mora)}}</span>
        <span>TOTAL PENDIENTE:{{currencyFormatter(totales.pendiente)}}</span>
        <span>TOTAL ABONO:{{currencyFormatter(totales.abono)}}</span>
        <span>TOTAL :{{currencyFormatter(totales.total)}}</span>
      </v-list-item-content>
</v-list-item>

  </template>


                  </v-data-table>

                 
                                 </div>
                            </v-col>
                            <!-- FIN COL:DETALLE CONTRATO-->


                            </v-row>
                           </v-col>
                           <!-- FIN COL GRUPO 2: -->

                  </v-row>
                 </v-form>
                 <!-- fn Formulario-formPagares  -->
                 




              </v-card>
            </v-col>

          </v-app>
        </td>
        <!-- fn contenido central ------------------------------------------------------------------------------------->
        <!-- BarraSecundaria ------------------------------------------------------------------------------------------>
        <td width="109" :max-height="this.windowSize.height-96" v-show="BarraSecundariaAprir">

          <div class="overflow-y-auto "
            v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px' }">
          </div>

        </td>
        <!-- fn BarraSecundaria --------------------------------------------------------------------------------------->


      </tr>
    </table>
    <!-- Modales -------------------------------------------------------------------------------------------------->
    <!-- ------------------------------------------------------ tb-data todo general -->
    <v-dialog label="myAlert" v-model="acti_tb_data" persistent transition="dialog-bottom-transition" fullscreen
      hide-overlay>
      <v-card>
        <v-toolbar dense flat color="#BDBDBD">
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"> </i>
          <v-toolbar-title class="font-weight-light"> REPORTE</v-toolbar-title>
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"> </i>

          <v-spacer></v-spacer>

          <!-- <v-tooltip top>
<template v-slot:activator="{ on }"> 
  <v-btn v-on="on"
                dark
                  small
                  color="deep-purple accent-2"
                  @click.prevent=""
                >
                  <i style="font-size: 25px;" class="fa fa-print"> </i>
                  Listado</v-btn>

 </template>
          <span>Imprimir Listado</span>
        </v-tooltip>  -->

          <v-btn color="grey darken-4" fab small @click="acti_tb_data = !acti_tb_data">
            <i style="font-size: 20px; color:#dd4b39;" class="fa fa-close"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field v-model="search" @keyup="filtro" label="Buscar" single-line hide-details>
                <template v-slot:prepend-inner>
                  <i style="font-size: 35px;" class="fa fa-search"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table :headers="[
              { text: 'Código', value: 'codigo', sortable:false, class: ['no-gutters black--text'] },
              { text: 'Descripcion', value: 'descripcion', sortable:false, class: ['no-gutters black--text'] }
            ]" dense :items="list" :search="search" @click:row="datostabla">
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
     <!-- ------------------------------------------------------ fn tb-data todo general -->
   <!-- ------------------------------------------------------ Modal-notificacion general -->
    <v-dialog label="myAlert" v-model="Elim_notif.estado" persistent max-width="350" transition="fab-transition">
      <template justify="center" v-slot:activator="{ on }"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i style="font-size: 28px;" class="fa fa-warning"></i>
            CONFIRMACION
            <i style="font-size: 28px;" class="fa fa-warning"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ Elim_notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn @click.prevent="
            eliminar(), (Elim_notif.estado = !Elim_notif.estado)
          " small>
            <i style="font-size: 20px;" class="fa fa-check"></i> Si
          </v-btn>

          <v-btn @click.prevent="Elim_notif.estado = !Elim_notif.estado" small>
            <i style="font-size: 20px;" class="fa fa-ban"></i> No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
   <!-- ------------------------------------------------------ Modal-notificacion general -->

    <!------------otras funciones---------------->
    <v-snackbar v-model="aalert.estado" :color="aalert.color" style="margin-top: 20%;" :vertical="true"
      :timeout="120000" top="top">
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

    <!-- ------------------------------------------------------ Modal- Reporte Basico-->
    <v-dialog transition="fab-transition" label="Modal Reporte Basico" v-model="dialogimprimirList" persistent
      max-width="80%" max-height="50%">
      <ModalReporteBasico @DataReporteBasico="DDataReporteBasico" :Datos="datosImprecion" />
    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal Reporte Basico-->


    <!-- fn Modales ----------------------------------------------------------------------------------------------->

  
  </div>
</template>
<script>
//import jsonPR from '../../prjson.json'
import VueAutonumeric from "../../components/AutoNumericNuevo";
import { EventBus } from "../../event-bus";
import BarraBusqueda2 from "../../components/BarraBusquedaDinam";
import BarraDinamicaNormal from "../../components/BarraDinamicaNormalPlus.vue";
import ContenidoBase from "../../components/ContenidoBase";
import ModalReporteBasico from "../../components/ModalReporteBasico";

import { currencyFormatter,
  FormatoFecha,
  HoraFormatter,
  HoraFormatter2,
  RedondeoValor,
  RedondeoBasico,
  RedondeoValorCantRed,
  fechaNueva,
  getParamFecha,
  validaCedRnc,
  getFechaZone,
  getHoraActual
} from "@/js/Funciones.js";
export default {
  components: {
    BarraBusqueda2,
    BarraDinamicaNormal,
    ContenidoBase,
    ModalReporteBasico,
    VueAutonumeric


  },
  created() {
    var json = {
      titulo: "",
      descripcion: "",
      save: true,
      eliminar: false,
      anular: false,
      nuevo: true,
      imprimir: true,
      accion: [
        "CXCTiposClientesNew",
        "CXCTiposClientesSave",
        "CXCTiposClientesRemove",
        "CXCTiposClientesAnular",
        "CXCTiposClientesPrintList"
      ]
    };
    EventBus.$emit("anularBotonesAccion", json);
  },
  mounted() {
    //EventBus.$on("abrirMenuizquierdo", this.abrirTabla);
    // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
    // EventBus.$on("CXCTiposClientesNew", this.new);
    // EventBus.$on("CXCTiposClientesSave", this.save);
    // EventBus.$on("CXCTiposClientesRemove", this.remove);
    // EventBus.$on("CXCTiposClientesAnular", this.remove);
    // EventBus.$on("CXCTiposClientesPrintList", this.imprimirList);
    EventBus.$on("emitCXCTiposClientes", this.datostabla);
    EventBus.$on("onResize", this.onResize);
  },

  data: () => ({

    //myJson: jsonPR,
    opcionImprecion:1,
    arrayPropiedases: {
      'items-per-page-options': [10, 15, 20, 50],
      'items-per-page-text': 'Cantidad de Registros Por Paginas',
      showFirstLastPage: false
    },
    dialogimprimirList: false,
    datosImprecion: {
      nombre: 'TIPOS CLIENTES',
      UrlImprimir: '/PagoPagares/Imprimir',
      UrlExel: '/PagoPagares/Excel',
      UrlCorreo: '/PagoPagares/Correo',
      secuencia: 1,
      documento: 0
    },

    isComponente:false,
    opcionFiltroPendiente:false,
    busquedaFiltro:{
      cliente:null

    },
    selectedPagare:[],
    listPagareCliente:[],
    RCaja:[],
    RBanco:[],
    RTipoInteres: [
      { codigo: 1, descripcion: "Dia", dia: 1, tipo: 1 },
      { codigo: 2, descripcion: "semanal", dia: 7, tipo: 1 },
      { codigo: 3, descripcion: "Quincenal", dia: 15, tipo: 1 },
      { codigo: 4, descripcion: "Mensual", dia: 30, tipo: 2 },
      { codigo: 5, descripcion: "Anual", dia: 365, tipo: 3 },
    ],

    ListaTiposClientes: [],
    Rcliente:[],
    windowSize: { width: "auto", height: "auto" },

totales:{
  pendiente:0,
  capital:0,
  interes:0,
  mora:0,
  abono:0,
  total:0
},

    DatosPagareFactura:null,
    PagoPagares: {
      codPagare:0,
      listaPagaredetalle:[],
      caja:null,
      cliente:null,
      opcion:1,
      monto:0,
      numCuenta:null,
      banco:null,
      tarjetaTipo:null,
      numeroTarjeta:null,
      completado:false,
      montoFactura:0,
      montoMora:0,
      montoInteres:0,
      conceptoIntere:"",
      conceptoMora:"",
      concepto:"",
      conceptoGeneral:"",
      ultimoConcepto:""
    },
    EstadoBtn: {
      BarraTablaDinamicaAprir: false,
      nuevo: true,
      guardar: false,
      eliminar: false,
      anular: false,
      imprimir: true,
      vercuenta: false,
      guardartemporal: false,
      restaurartemporal: false,
      importarDato: false,
      cargarProducto: false,
      ImprimirproductoInv: false,
    },


    files: [],
    text: "",
    valid: true,
    BarraTablaDinamicaAprir: false,
    BarraSecundariaAprir: false,

    headers: [{ text: "Tipos Clientes", value: "descripcion" }],

    slotlist: [
      { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
      {
        dt0: "descripcion",
        dt1: null,
        dt2: null,
        dt3: 1,
        dt4: "Descripcion:"
      },
      { dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo" },
    ],

    formData: null,
    list: [],
    search: "",
    acti_tb_data: false,
    Elim_notif: {
      estado: false,
      nombre: "¿Seguro que desea anular este registro?"
    },

    aalert: {
      estado: false,
      color: null
    },

  }),

  //   destroyed() {
  //     location.reload();
  //   },
  methods: {
     currencyFormatter,
        FormatoFecha,
        HoraFormatter,
        HoraFormatter2,
        RedondeoValorCantRed,
        fechaNueva,
        getParamFecha,
        validaCedRnc,
        getFechaZone,
        getHoraActual,

    onResize(e) {
      //this.windowSize = e
    },

  // Abriendo una panel donde mustra los datos en una tabla.
    abrirTabla() {
      this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir;

      if (this.BarraTablaDinamicaAprir == true) {

        this.filtro()
        // EventBus.$emit("actualizaBarraDinaicaLim");


      }

    },

    // Un método que se llama cuando el usuario hace clic en una fila de la tabla.
    datostabla(e) {
      this.PagoPagares = JSON.parse(JSON.stringify(e));
      this.acti_tb_data = false
    },


    aplicarPagares(){



      

      if (this.$refs.formPagares.validate()) {

        var ObjProRow = this.DatosPagareFactura.pagareDetalleList.filter((ee) => ee.abono>0)

        if(ObjProRow.length==0){
          this.alerta("debe de aplicarle almenos un movimiento a la DISTRIBUCIÓN DE CUOTAS ", "error");
          return
        }
       //EventBus.$emit("loading", true);
        this.PagoPagares.listaPagaredetalle=ObjProRow
        this.PagoPagares.codPagare=this.DatosPagareFactura.secuencia
        var contPendiente=this.totales.pendiente
        this.$axios
          .post(this.$hostname + this.$hName + "/pagare/salvarRealizarpago", this.PagoPagares, { headers: this.$store.getters.GetheadersAxios })
          .then(res => { 
            var PAGARE=res.data.pagare
            PAGARE.contPendiente=contPendiente
            this.ImprimirRecibo(PAGARE)
            this.alerta("Dato guardado correctamente!", "bien")
          })
          .catch(error => this.alerta("Dato no guardado correctamente", "error"));

      }else{
        this.alerta("Los campos en rojo son requeridos", "error");
      }
      



    },


   // Envío de una solicitud POST al servidor.
    save() {
      /*if (this.$refs.form.validate()) {
        EventBus.$emit("loading", true);
        if (this.PagoPagares.codigo > 0) {
            this.PagoPagares.fechaModificacion= new Date()
            this.PagoPagares.usuarioModifico= this.$store.getters.GetdatosInfUsu.usuario.username
           }else{
            this.PagoPagares.fechaCreacion= new Date()
           this.PagoPagares.usuarioCreacion= this.$store.getters.GetdatosInfUsu.usuario.username
           }

        this.$axios
          .post(this.$hostname + this.$hName + "/zona/salvar/", this.PagoPagares, { headers: this.$store.getters.GetheadersAxios })
          .then(res => { this.alerta("Dato guardado correctamente!", "bien")})
          .catch(error => this.alerta("Dato no guardado correctamente", "error"));
      } else {
        this.alerta("Los campos en rojo son requeridos", "error");
      }*/
    },
    remove() {
      if (this.PagoPagares.codigo != 0 && this.PagoPagares.codigo != null) {

        this.Elim_notif.estado = !this.Elim_notif.estado;
      } else {
        this.alerta("Seleccione un tipos de cliente para eliminar", "error")
      }


    },
    // Envío de una solicitud de publicación al servidor.
    eliminar() {
      if (this.PagoPagares.codigo != 0) {
        EventBus.$emit("loading", true);
        this.$axios
          .post(this.$hostname + this.$hName + "/zona/borrar/", this.PagoPagares, { headers: this.$store.getters.GetheadersAxios })
          .then(res => {
            this.alerta("Dato eliminado correctamente!", "bien");
          })
          .catch(error =>
            this.alerta("El tipo de cliente que está intentando borrar lo está usando algún cliente", "error"));
      }

    },
    anular() {
      if (this.Elim_notif.estado) {

        this.$axios
          .post(this.$hostname + this.$hName + "/zona/borrar/", this.PagoPagares, { headers: this.$store.getters.GetheadersAxios })
          .then(res => { this.alerta("Dato eliminado correctamente!", "bien") })
          .catch(error => this.alerta("Dato no eliminado correctamente", "error"));
      }
    },
  // Un método que se llama cuando el usuario hace clic en un botón y 
  //activa un modal con la opcion de impreciones.

  imprimirList() {


    if(this.opcionImprecion===1){
      if(this.PagoPagares.caja!=null){
       // this.ImprimirMedicPend(jsonPR.obj.reciboFact)
       this.DatosPagareFactura.contPendiente=this.totales.pendiente
       this.ImprimirRecibo(this.DatosPagareFactura)
      }else{
        this.alerta("Seleccione una caja  ", "error");
        return
      }
      
    }


    if(this.opcionImprecion===2){
      this.imprimirListPDF()
    }
    // this.DatosPagareFactura.
   // console.log('Infooo--imprimirList->',jsonPR.obj)


   // this.imprimirListPDF()
  },


    imprimirListPDF() {
      
// console.log('Infooo--imprimirList->',jsonPR.obj)
    //  this.dialogimprimirList = true
      EventBus.$emit("loading", true);
      var headers = this.$store.getters.GetheadersAxios

      //.post(_this.$hostname + _this.$hName + _this.Datos.UrlImprimir, obj, { headers: _this.$store.getters.GetheadersAxios })

      var obj={
        codigopag:this.DatosPagareFactura.secuencia,
        where:` where pd.pagare=${this.DatosPagareFactura.secuencia}`

      }

      this.$axios.post(this.$hostname + this.$hName + "/pagare/ImprimirContratoPagare",obj, { headers: headers }).then(res => {
       
       
        EventBus.$emit("loading", false);

        var _this=this;
        setTimeout(function(){ 

       
          if (res.data.includes(".txt")) {
            var fileName = "prueba.txt";
            var url = _this.$hostname + _this.$hName + '/configuraciones/texts/';
          } else {
            var fileName = "prueba.pdf";
            var url = _this.$hostname + _this.$hName + '/configuraciones/imprimir/';
          }
       
         /*var _this = this;
        setTimeout(function () {}, 800);*/
         
          //Create XMLHTTP Request.
          var req = new XMLHttpRequest();
          req.open("GET", url, true);
          // req.setRequestHeader('AutUser', this.$store.getters.GetheadersAxios.AutUser);
          req.setRequestHeader('Authorization', _this.$store.getters.GetheadersAxios.Authorization);
          req.setRequestHeader('X-TENANT-ID', _this.$store.getters.GetheadersAxios["X-TENANT-ID"]);
          req.setRequestHeader('Content-Type', _this.$store.getters.GetheadersAxios["Content-Type"]);
          req.setRequestHeader('ruta', res.data);
          req.responseType = "blob";
          req.onload = function () {
            //Convert the Byte Data to BLOB object.
            if (res.data.includes(".txt")) {
              var blob = new Blob([req.response], { type: "text/plain" });
              var isIE = false;
              if (isIE) {
                navigator.msSaveBlob(blob, fileName);
              } else {
                var url = URL || webkitURL;
                var link = url.createObjectURL(blob);
                // let pdfWindow = window.open("d.txt")
                // pdfWindow.document.write("<embed width='100%' height='100%' type='text/plain' src='"+link+"' ></embed>")
                var downloadLink = document.createElement("a");
                downloadLink.href = link;
                downloadLink.download = "reporte.txt";
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
              }
            } else {
              var blob = new Blob([req.response], { type: "application/pdf" });
              var isIE = false || !!document.documentMode;
              if (isIE) {
                navigator.msSaveBlob(blob, fileName);
              } else {
                console.log('blob-->',blob)
                var url = URL || webkitURL;
                var link = url.createObjectURL(blob);
                /*let pdfWindow = window.open("d.pdf")
                pdfWindow.document.write("<embed width='100%' height='100%' type='application/pdf' src='" + link + "' ></embed>")*/
                // console.log('--> lolo', link)
          var PDF=`${link}`;
          EventBus.$emit("openPDF",PDF ,'PagoAPagares');
        

          return
              }
            }
            //Check the Browser type and download the File.
          };
          req.send();
          // this.Reparaloading = false
          EventBus.$emit("loading", false);

        }, 300);

          //EventBus.$emit("openPDF",PDF ,'PagoAPagares');

      })
      .catch(error =>{EventBus.$emit("loading", false); });
     
      //this.ImprimirMedicPend(jsonPR.obj.reciboFact)
      


    },


    ImprimirRecibo(OBJ){

      // console.log('Conf*-Inf->',this.$store.getters.GetConfiguracionGeneral)
    //  if (localStorage.printerSelect != null) { }
    // this.$store.getters.GetOtrasConfigPv;
    // conf: JSON.parse(sessionStorage.ConfiguracionGeneral).config,
              var msg = {
                accion: "print",
                formato: this.PagoPagares.caja.formatoimpresioncontado.trim(),
                impresora: JSON.parse(localStorage.printerSelect).nombre,
                data: this.$store.getters.GetConfiguracionGeneral,
                obj: OBJ,
                caja: this.PagoPagares.caja,
                cajero: this.$store.getters.GetOtrasConfigPv.cajero,
                accionTitulo:"IMPRECION",
                schema: this.$store.getters.GetheadersAxios["X-TENANT-ID"]
              };
           

            this.imprimir(msg, "pagare");
//:cajaSelect="caja"

    },



    imprimir(datos, operacion) {
      datos.operacion = operacion;
      if (datos.formato === "fiscale") {
        this.$axios.get("http://localhost:15999/impresora/imprimir/validad").then(res => {
          if (res.data.LastError ===0) {
          this.$axios
          .post("http://localhost:15999/impresora/imprimir", datos)
          .then((res) => {
            this.nuevoRegistro()
          })
          .catch((error) => { 
            this.ejecucion=true 
            console.error(error)
          });
          }else{
            this.alerta("La impresora esta desconectada o esta apagada!!!","error")
            return;
          }
        })
        .catch((error) => { 
            this.ejecucion=true 
            console.error(error)
          });
      }else{
        this.$axios
          .post("http://localhost:15999/impresora/imprimir", datos)
          .then((res) => {
            //this.nuevoRegistro()
          })
          .catch((error) => {
            console.error(error)
            this.ejecucion=true 
          });
      }
    },



    DDataReporteBasico(e) {
      this.dialogimprimirList = e
    },


    // Creando un nuevo objeto y asignándolo a la variable PagoPagares.
    newwnuevo() {
      this.opcionFiltro=false
      this.opcionImprecion=1
      this.BarraTablaDinamicaAprir = false
    //   this.PagoPagares= {
    //   caja:null,
    //   cliente:null,
    //   completado:false
    // },

this.totales={
  pendiente:0,
  capital:0,
  interes:0,
  mora:0,
  abono:0,
  total:0

}

if(this.isComponente==true){
var ObjCaja=this.PagoPagares.caja

var _this = this;
        setTimeout(function () {
          _this.PagoPagares.caja=ObjCaja
        }, 500);

}
this.selectedPagare=[]
this.listPagareCliente=[]
this.DatosPagareFactura=null
this.PagoPagares= {
      codPagare:0,
      listaPagaredetalle:[],
      caja:null,
      cliente:null,
      opcion:1,
      monto:0,
      numCuenta:null,
      banco:null,
      tarjetaTipo:null,
      numeroTarjeta:null,
      completado:false,
      montoFactura:0,
      montoMora:0,
      montoInteres:0,
      conceptoIntere:"",
      conceptoMora:"",
      concepto:"",
      conceptoGeneral:"",
      ultimoConcepto:""
    }


     // EventBus.$emit("actualizaBarraBusqueda2");
      EventBus.$emit("loading", false);
    },


  async buscarPagare(){
//this.PagoPagares.cliente.codigo
      if(this.PagoPagares.cliente==null|| !this.PagoPagares.cliente.hasOwnProperty('codigo') ){
        this.alerta(" debe seleccionar un cliente", "error");
        return
      }

      await this.$axios
  .get(this.$hostname + this.$hName + "/pagare/findallByCodigoCliente/"+this.PagoPagares.cliente.codigo, { headers: this.$store.getters.GetheadersAxios })
  .then(res => {
    if(res.data.length>0){
      this.listPagareCliente=res.data
    }else{
      this.listPagareCliente=[]
      this.alerta("El cliente seleccionado no posee contrato", "error");
    }
    
  });

    },


// Realizar una solicitud GET al servidor y devolver los datos al componente Vue.
cargarCliente() {

this.$axios.get(this.$hostname + this.$hName + '/clientes/findtodo/a/3/25/0', { headers: this.$store.getters.GetheadersAxios })
  .then(res => (this.Rcliente = res.data))
},


// El código anterior intenta verificar si el usuario ha seleccionado un cliente del menú
// desplegable. Si el usuario no ha seleccionado un cliente, entonces el código está intentando
// establecer el cliente en nulo.
SelctCbClient() {

var _this = this;
setTimeout(function () {
  if (_this.PagoPagares.cliente == null) {
    _this.PagoPagares.cliente = "";
  }

  if (!_this.PagoPagares.cliente.hasOwnProperty('codigo')) {
    _this.PagoPagares.cliente = "";
    _this.PagoPagares.cliente = null;
    return;
  }
}, 300);
},

CbFilcliente(e) {
//console.log(e.target.value)

if (e.target.value.length >= 0) {

  this.$axios
    .get(
      this.$hostname +
      this.$hName +
      "/clientes/findtodo/" +
      (e.target.value === null || e.target.value.length==0 ? 'A' : e.target.value)+
      "/3/25/0",
      { headers: this.$store.getters.GetheadersAxios }
    )
    .then(res => (this.Rcliente = res.data));
}
},


 // Llamar a una API y obtener los datos de la API.
 cargarCaja() {
      this.$axios.get(this.$hostname + this.$hName + '/cajas/findAllActivos', { headers: this.$store.getters.GetheadersAxios })
        .then(res => (this.RCaja = res.data))

    },


// Comprobando si el usuario ha seleccionado un valor del menú desplegable. Si no, está mostrando un
   // mensaje de error.
   SelctCbCaja() {
var _this = this;
setTimeout(function () {
  if (_this.PagoPagares.caja== null) {
    _this.PagoPagares.caja= "";
  }

  if (!_this.PagoPagares.caja.hasOwnProperty('codigo')) {
    _this.PagoPagares.caja= "";
    _this.PagoPagares.caja= null;
    return;
  }
}, 300);

},


 // Llamar a la API y obtener los datos de la API.
 cargarBanco() {
      this.$axios.get(this.$hostname + this.$hName + '/tarjeta/findall/', { headers: this.$store.getters.GetheadersAxios })
        .then(res => (this.RBanco = res.data))

    },

    // Comprobando si el valor de la selección es nulo o indefinido.
    SelctCbBanco() {
      var _this = this;
      setTimeout(function () {
        if (_this.PagoPagares.tarjetaTipo == null) {
          _this.PagoPagares.tarjetaTipo= "";
        }

        if (!_this.PagoPagares.tarjetaTipo.hasOwnProperty('codigo')) {
          _this.PagoPagares.tarjetaTipo = "";
          _this.PagoPagares.tarjetaTipo = null;
          _this.alerta("Seleccione un tipo de tarjecta", "error");
          return;
        }
      }, 300);

    },



//esto es para desactivar los campos cuando el fomulario es heredado de otro formulario 
disableCompntsCamp(){

if(this.isComponente==true){ 
  return true
}else{
  return false
}

},

ObtenerDatoSelectPagare(e){
this.DatostablaPagare(e.item);
},

DatostablaPagare(e){
  this.opcionImprecion=1
  this.selectedPagare=[]
  var ObjProRow = this.RTipoInteres.filter((ee) => ee.codigo == e.tipoInteres);
  var OBJ= JSON.parse(JSON.stringify(e))
  OBJ.fecha=e.nuevaFecha
  OBJ.tipoInteres=ObjProRow[0]
  OBJ.pagareDetalleList=[]
  var pagareDetalleList= e.pagareDetalleList

  //this.totales.pendiente=0
  this.totales={
  pendiente:0,
  capital:0,
  interes:0,
  mora:0,
  abono:0,
  total:0,
  pendienteBK:0

},


  Promise.all(pagareDetalleList.map(async (element) => { 
    element.pendienteBk = JSON.parse(JSON.stringify(element.pendiente))
    element.saldadoBk = JSON.parse(JSON.stringify(element.saldado))
    element.totalBk=JSON.parse(JSON.stringify(element.total))
    element.abono =0
    this.totales.pendiente+=element.pendiente
    this.totales.capital+=element.capital
    this.totales.abono+=element.abono
    this.totales.interes+=element.interes
    this.totales.mora+=element.interesMoraValor
    this.totales.total+=element.total
    this.totales.pendienteBK+=element.pendienteBk
  }));

  pagareDetalleList.sort(function (a, b) {
              if (a.codigo > b.codigo) {return 1;}
              if (a.codigo < b.codigo) {return -1;
              }
              // a must be equal to b
              return 0;
            });


  this.DatosPagareFactura=OBJ
  this.DatosPagareFactura.pagareDetalleList=pagareDetalleList
    this.selectedPagare.push(e)
},

blurMontopagar(){

  
  var _this=this;
setTimeout(function(){ 

if(_this.PagoPagares.monto>0){
var pendienteBk= _this.RedondeoValorCantRed(_this.totales.pendienteBK,2)
var montoPaga= _this.RedondeoValorCantRed(_this.PagoPagares.monto,2)

if(montoPaga>pendienteBk){
_this.PagoPagares.monto=JSON.parse(JSON.stringify(pendienteBk))
  _this.alerta(`EL MONTO DIGITADO $.${_this.currencyFormatter(montoPaga)} SUPERA EL MONTO PENDIENTE $.${_this.currencyFormatter(pendienteBk)} `,"warning")
}

  }
      }, 300);

},


procesarCalculoPagos(){
  this.PagoPagares.montoFactura=0
  this.PagoPagares.montoMora=0
  this.PagoPagares.montoInteres=0
  this.PagoPagares.conceptoIntere=""
  this.PagoPagares.conceptoMora=""
  this.PagoPagares.conceptoGeneral=""
   this.PagoPagares.ultimoConcepto=""
  // this.totales.pendiente=0
  this.totales={
  pendiente:0,
  capital:0,
  interes:0,
  mora:0,
  abono:0,
  total:0,
  pendienteBK:0

}

  var VAR_ABONO=JSON.parse(JSON.stringify(this.PagoPagares.monto))
 if(this.DatosPagareFactura!=null&& this.DatosPagareFactura.pagareDetalleList.length>0){
  Promise.all(this.DatosPagareFactura.pagareDetalleList.filter((ee) => ee.saldadoBk===false && ee.pendienteBk >0).map(async (element) => { 

    if(VAR_ABONO>0){
    if(VAR_ABONO>=(element.pendienteBk)){
      var VALOR_MORA=this.calcularMoraDistCuota(element)
      const PENDIENTE=JSON.parse(JSON.stringify((element.pendienteBk+VALOR_MORA)))
      if(VAR_ABONO>=PENDIENTE){
        element.abono= PENDIENTE
        element.pendiente=0
      }else{
        element.pendiente=this.RedondeoValorCantRed((PENDIENTE-VAR_ABONO),2)
        element.abono=this.RedondeoValorCantRed((PENDIENTE-element.pendiente),2)
        
      }
      
      VAR_ABONO-=this.RedondeoValorCantRed(element.abono,2)

      if(VALOR_MORA>0){
        element.interesMoraValor=JSON.parse(JSON.stringify(VALOR_MORA))
        element.interesMoraPorciento=JSON.parse(JSON.stringify(this.DatosPagareFactura.interesMora))
        element.total=JSON.parse(JSON.stringify(element.totalBk+VALOR_MORA))
         //interesMoraPorciento: 0
        //interesMoraValor: 0
      }
    }else{
      element.abono=JSON.parse(JSON.stringify(this.RedondeoValorCantRed(VAR_ABONO,2)))
      element.pendiente=JSON.parse(JSON.stringify(this.RedondeoValorCantRed((element.pendienteBk-VAR_ABONO),2)))
      VAR_ABONO=0
      element.fechaPago=null
    }
    if(element.pendiente==0){element.saldado=true}

  }else{
    
    element.pendiente = JSON.parse(JSON.stringify(this.RedondeoValorCantRed(element.pendienteBk,2)))
    element.saldado = JSON.parse(JSON.stringify(this.RedondeoValorCantRed((element.saldadoBk),2)))
    element.total =JSON.parse(JSON.stringify(this.RedondeoValorCantRed((element.totalBk),2)))
    element.abono =0
    element.interesMoraValor=0
    element.interesMoraPorciento=0
    element.fechaPago=null
    
  }

  
if(element.saldadoBk===false && element.saldado===true){
  this.PagoPagares.montoFactura+=this.RedondeoValorCantRed(element.capital,2)
  this.PagoPagares.montoMora+=this.RedondeoValorCantRed(element.interesMoraValor,2)
  this.PagoPagares.montoInteres+=this.RedondeoValorCantRed(element.interes,2)
  element.fechaPago=this.fechaNueva()
  
 // this.PagoPagares.conceptoMora=""
 this.PagoPagares.conceptoIntere+=`Interes a CONT#:${this.DatosPagareFactura.secuencia},PAGO#:${element.pago.trim()}. \n`
 this.PagoPagares.concepto+=`CONT#:${this.DatosPagareFactura.secuencia},PAGO#:${element.pago.trim()}. \n`
}

if(element.abono>0){
  if(element.saldado===true){
    this.PagoPagares.conceptoGeneral+=`Pago a CONT#:${this.DatosPagareFactura.secuencia},PAGO#:${element.pago.trim()}. \n`
    this.PagoPagares.ultimoConcepto+=`Pago de $${this.currencyFormatter(element.abono)} a CONT#:${this.DatosPagareFactura.secuencia},PAGO#:${element.pago.trim()}. \n`
  }else{
    this.PagoPagares.ultimoConcepto+=`Abono de $${this.currencyFormatter(element.abono)} a CONT#:${this.DatosPagareFactura.secuencia},PAGO#:${element.pago.trim()}. \n`
  }

}

this.totales.pendiente+=this.RedondeoValorCantRed(element.pendiente,2)
    this.totales.capital+=this.RedondeoValorCantRed(element.capital,2)
    this.totales.abono+=this.RedondeoValorCantRed(element.abono,2)
    this.totales.interes+=this.RedondeoValorCantRed(element.interes,2)
    this.totales.mora+=this.RedondeoValorCantRed(element.interesMoraValor,2)
    this.totales.total+=this.RedondeoValorCantRed(element.total,2)
    this.totales.pendienteBK+=this.RedondeoValorCantRed(element.pendienteBk,2)
 
  }));
}
},


calcularMoraDistCuota(e){
// this.DatosPagareFactura.prorroga
  if(this.DatosPagareFactura.interesMora>0){

     var PRORROGA=this.DatosPagareFactura.prorroga
  var FECHA_HOY=new Date()
  var FECHA_Prorrogada=new Date(this.getParamFecha(e.nuevaFechaVencimiento));
  FECHA_Prorrogada.setDate(FECHA_Prorrogada.getDate() + (PRORROGA!=null?PRORROGA:0));
  //FECHA_Prorrogada =new Date(FECHA_Prorrogada)
  var F1=this.getParamFecha(FECHA_HOY)
  var F2=this.getParamFecha(FECHA_Prorrogada)
if(F1>F2){
  //interesMoraPorciento: 0
  //interesMoraValor: 0
  //element.interesMoraPorciento=this.DatosPagareFactura.interesMora
   // var PORC_MORA=3
  var PORC_MORA=this.DatosPagareFactura.interesMora
 var moraValor =((e.totalBk*PORC_MORA)/100)
 return this.RedondeoValorCantRed(moraValor,2)

}else{
 return 0
}

  }else{
    return 0
  }
},

estadoListaContrato(e){
var ESTADO_COMPLETO=false
// var ObjProRow = this.ListaProdxLote.filter((ee) => ee.fechaVencimiento.codigo != e.lote && ee.fechaVencimiento.fecha < FechSel);
if(e!=null){
var ObjProRow = e.pagareDetalleList.filter((ee) => ee.saldado===true)
if((ObjProRow.length-1)==e.cantidadCuotas){
  ESTADO_COMPLETO= true
}
}

return ESTADO_COMPLETO
},


estadoListaContratoBk(e){
var ESTADO_COMPLETO=false
// var ObjProRow = this.ListaProdxLote.filter((ee) => ee.fechaVencimiento.codigo != e.lote && ee.fechaVencimiento.fecha < FechSel);
if(e!=null){
var ObjProRow = e.pagareDetalleList.filter((ee) => ee.saldadoBk===true)
if((ObjProRow.length-1)==e.cantidadCuotas){
  ESTADO_COMPLETO= true
}
}

return ESTADO_COMPLETO
},




filterlistPagareCliente(OBJ){
// listPagareCliente

var BOOL=this.opcionFiltroPendiente




return OBJ.filter((ee) => this.estadoListaContrato(ee)===BOOL)

//  return OBJ;
},





  alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e);

        this.newwnuevo();
      }

      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e);

        this.ejecucion = false;
        EventBus.$emit("loading", false);
      }
      if (l == "warning") {
        (this.aalert.estado = true),
          (this.aalert.color = "warning"),
          (this.aalert.nombre = e);
        this.aalert.right = false
        this.aalert.top = true
        this.aalert.timeout = 5000
        this.ejecucion = false;
        EventBus.$emit("loading", false);
      }
    },
    actualiza_tb_ver() {
      this.acti_tb_data = !this.acti_tb_data;
      this.filtro();
    },

  // Hacer una llamada API al backend y obtener los datos de la base de datos.
    async filtro() {


      await this.$axios
        .get(this.$hostname + this.$hName + "/zona/findall", { headers: this.$store.getters.GetheadersAxios })
        .then(res => {
          this.list = res.data;
        });

    }
  },


  computed: {

    ActDescBtn() {


      if (this.PagoPagares.codigo > 0) {
        this.EstadoBtn = {
          BarraTablaDinamicaAprir: false,
          nuevo: true,
          guardar: false,
          eliminar: true,
          anular: false,
          imprimir: true,
          vercuenta: false,
          guardartemporal: false,
          restaurartemporal: false,
          importarDato: false,
          cargarProducto: false,
          ImprimirproductoInv: false,
        }
      }


      if (this.PagoPagares.codigo <= 0) {


        this.EstadoBtn = {
          BarraTablaDinamicaAprir: false,
          nuevo: true,
          guardar: false,
          eliminar: false,
          anular: false,
          imprimir: true,
          vercuenta: false,
          guardartemporal: false,
          restaurartemporal: false,
          importarDato: false,
          cargarProducto: false,
          ImprimirproductoInv: false,
        }
      }


      this.windowSize=JSON.parse(JSON.stringify(this.$store.getters.GetwindowSize))   
    }
  }


};
</script>

<style>

</style>
